import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { PaymentResponse } from '@utils/interfaces';
import { useOBQuery } from '@hooks/useOBQuery';

interface PaymentsRequest {
  practiceId: string;
}

const useGetPaymentMethods = ({ practiceId }: PaymentsRequest) => {
  const url = useApiUrl(
    OBRoutes.PaymentMethods,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##practiceId', practiceId);

  return useOBQuery<PaymentResponse>(url, {
    enabled: !!url && !!practiceId,
    staleTime: 600000,
  });
};

export default useGetPaymentMethods;
